import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LandingPageAppResource from './LandingPageAppResource';

export const REAL_ESTATE_AGENT = 'real-estate-agent';
export const LOAN_OFFICER = 'loan-officer';

export const DESTINED_TO = {
  REAL_ESTATE_AGENT,
  LOAN_OFFICER
}
class LandingPagePhoneAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-phone';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/phones';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageUuid',
      'phone',
      'type',
      'destinedTo',
      'landingPage',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPage:             LandingPageAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      landingPage: 'landing_page_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      landingPageUuid: {
        type: 'string',
      },
      phone: {
        type: 'string',
        presence:                 true,
        length: {
          maximum: 255,
        },
      },
      type: {
        type: 'string',
        presence:                 true,
        length: {
          maximum: 255,
        },
      },
      destinedTo: {
        type: 'string',
        inclusion:[REAL_ESTATE_AGENT,LOAN_OFFICER]
      },
    };
  }

}

export default LandingPagePhoneAppResource;
